/**
 *
 * Asynchronously loads the component for ItemsPerPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ItemsPerPage = lazyLoad(
  () => import('./index'),
  module => module.ItemsPerPage,
);
